import { render, staticRenderFns } from "./AssistantMessageFeedback.vue?vue&type=template&id=3b0299dd&scoped=true"
import script from "./AssistantMessageFeedback.vue?vue&type=script&lang=js"
export * from "./AssistantMessageFeedback.vue?vue&type=script&lang=js"
import style0 from "./AssistantMessageFeedback.vue?vue&type=style&index=0&id=3b0299dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0299dd",
  null
  
)

export default component.exports